"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.Method = exports.AddToBasketEvent = void 0;
const Name = exports.Name = 'add-to-basket';
const AddToBasketEvent = exports.AddToBasketEvent = Name;
let Method = exports.Method = /*#__PURE__*/function (Method) {
  Method["BUY_FOR_MONEY"] = "BUY_FOR_MONEY";
  Method["BUY_FOR_POINTS"] = "BUY_FOR_POINTS";
  return Method;
}({});
//# sourceMappingURL=index.js.map